import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=5ebcbc0e"
import script from "./EventItem.ts?vue&type=script&lang=ts&external"
export * from "./EventItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports